const generateStyle = theme => {
  return {
    content: {
      display: 'flex',
      flex: '1',
      alignItems: 'center',
      gap: theme.spacing.small,
    },
    topNavBar: {
      flexGrow: '1',
      flexShrink: '1',
    },
  }
}

export default generateStyle
